define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/config",
	"csi/def",
	"csi/def/Action",
	"csi/def/AddPath",
	"csi/def/Field",
	"csi/def/Relationship",
	"csi/def/ViewRef",
	"csi/form/Widget",
	"csi/locale",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Query"
], function(declare, lang, csi, _, config, def, Action, AddPath, Field, Relationship, ViewRef, Widget, locale, csiStore, Names, xml, Query) {
	var _ThemePlacementNames = declare(Names, {
		_processResultNode: function(/*Node*/node, /*Cache*/cache) {
			//S10146 summary: add Material Name after ThemePlacement Name
			var material = cache.getNode(node.Actual);
			var item = {$: node.$URL, Name: locale.getNodeConfiguredName(node, cache) + " " + locale.getNodeConfiguredName(material, cache), node: node};
			return item;
		}
	});

	var FIELD_BOM_SUBTYPE = "BOMSubtype";
	var FIELD_COLORWAYS = "ColorColorways";
	var FIELD_SECTION = "BomSection";
	var FIELD_STYLES = "Styles";
	var FIELD_PLACEMENTS = "ThemePlacements";
	var FIELD_INCLUDE_BLANKS = "IncludeBlankAttributes";

	return declare(Widget, {
		_resolveView: function() {
			var params = {defaultAll: true};
			var defView = this.defView;

			if (this.getViewNode().AllSections.length > 0) {
				this.insertField(lang.mixin(new Field(), {
					m_label: FIELD_SECTION,
					m_typeControl: def.FIELD_MULTI_SELECT,
					widgetParams: params
				}), 0);
			}

			defView.addField(lang.mixin(new Field(), {
				m_label: FIELD_PLACEMENTS,
				m_typeControl: def.FIELD_MULTI_SELECT,
				m_bRequired: true,
				widgetParams: params,
				idParameter: "ThemePlacement",
				m_dependency: FIELD_SECTION,
				m_relationship: lang.mixin(new Relationship(), {
					m_url: this.getViewURL(),
					m_id: "Items",
					// dependency path is needed to display the material next to the placement in the dialog, see _ThemePlacementNames function
					m_depPaths: ["Child:Actual"]
				})
			}));

			defView.addField(lang.mixin(new Field(), {
				m_label: FIELD_STYLES,
				m_typeControl: def.FIELD_MULTI_SELECT,
				m_bRequired: true,
				widgetParams: params,
				idParameter: "Style"
			}));

			if (defView.m_formData.getSource().m_action.m_id != "MassDelete") {
				defView.addField(lang.mixin(new Field(), {
					m_label: FIELD_COLORWAYS,
					m_typeControl: def.FIELD_MULTI_SELECT,
					m_bRequired: false,
					widgetParams: {addItemAll: true},
					idParameter: "ColorColorway",
					m_relationship: lang.mixin(new Relationship(), {
						m_url: this.getViewURL(),
						m_id: FIELD_COLORWAYS
					})
				}));
			}

			if (config.hasSubtype("ApparelBOM")) {
				var q = new Query()
					.Attr("Active", xml.OP_EQUALS, true, "Child:Settings")
					.Attr("Published", xml.OP_EQUALS, true);

				if (defView.m_formData.getSource().m_action.m_id == "MassDelete")
					q.Attr("LockThemePlacementList", xml.OP_EQUALS, false, "Child:Settings");

				defView.addField(lang.mixin(new Field(), {
					m_label: FIELD_BOM_SUBTYPE,
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_bRequired: true,
					bPersist: true,
					idParameter: FIELD_BOM_SUBTYPE,
					m_relationship: lang.mixin(new Relationship(), {
						m_typeNode: "ApparelBOMSubtype",
						m_query: q
					})
				}));
			}

			this._setBOMType();

			// This form is also being used for the MassDelete action - where it is not needed, so the if statement is explicit for MassUpdate and MassCreateUpdate
			var action = defView.getFormData().getSource().getAction();
			if (action && (action.m_id == "MassCreateUpdate" || action.m_id == "MassUpdate")) {
				defView.addField(lang.mixin(new Field(), {
					m_label: FIELD_INCLUDE_BLANKS,
					m_typeControl: def.FIELD_CHECKBOX,
					idParameter: FIELD_INCLUDE_BLANKS,
					bPersist: true
				}));
			}

			this.inherited(arguments);
		},

		_setBOMType: function() {
			// summary: S10825 set a read only value for BOM Type field from Theme BOM Type if exists
			// same function appears in MassCreateStyleBOMsForm.js
			var fd = this.defView.m_formData;
			var theme = fd.getParent();
			var themeBOMType = theme ? theme.ThemeBOMType : null;

			if (xml.isValidURL(themeBOMType)) {
				this.addFixedValue(FIELD_BOM_SUBTYPE, themeBOMType);
			}
		},

		_buildView: function() {
			this.addDefaultValue(FIELD_COLORWAYS, this.EMPTY_COLORWAY_URL);
			this.inherited(arguments);
		},

		getFieldStore: function(/*Field*/field, /*String*/value) {
			var ac = this.getFormData().getSource();

			switch (field.getControlName()) {
				case FIELD_PLACEMENTS:
					// special store to return ThemePlacementName MaterialName
					// add dependency path to get the Material
					var q = new Query();
					var selectedSectionNames = this.defView.getFieldValue(FIELD_SECTION);

					if (selectedSectionNames != null && selectedSectionNames.length > 0) {
						var selectedSections = _.filter(this.getViewNode().AllSections, function(cnl) {
							var section = ac.getCache().getNode(cnl);
							if (!section || !xml.isValidURL(cnl))
								return false;
							return _.contains(selectedSectionNames, section.$Name);
						});

						// Add the "blanks" section if it is present.
						if (_.contains(selectedSectionNames, xml.VALUE_BLANK)) {
							selectedSections.push(csi.EMPTY_URL);
						}

						if (selectedSections != null && selectedSections.length > 0) {
							_.each(selectedSections, function(section) {
								this.RefAttr("DSSection", xml.OP_EQUALS, section);
							}, q.Or());
						}

						field.m_relationship.addQuery(q, true);
					}
					var storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), field.m_relationship, null, {customOperation: true});
					storeOptions.request.addDependencyPaths(field.m_relationship.m_depPaths);
					return new _ThemePlacementNames(storeOptions);

				case FIELD_SECTION:
					return ac._sectionsStore;

				case FIELD_STYLES:
					var params = {
						m_typeNode: "Style",
						m_addPaths: [lang.mixin(new AddPath(), {
							m_path: "Parent:Theme"
						})],
						m_query: new Query()
							.Attr2("TDSMap", xml.OP_EQUALS, {
								Path: "Child:ProductType/Child:ProductionConfig",
								Index: "ApparelBOM",
								SValue: true
							})
							.Attr("Active", xml.OP_EQUALS, true)
					}

					var rel = lang.mixin(new Relationship(), params);
					var storeOptions = csiStore.namesOptionsByRelationship(this.getContext(), rel);
					storeOptions.action = lang.mixin(new Action(), {
						m_name: locale.resource("AggregateInline_Name", [field.m_label]),
						m_viewRef: lang.mixin(new ViewRef(), {
							m_id: "ThemeStyles",
							m_url: this.urlRoot
						})
					});

					return new Names(storeOptions);

				default:
					return this.inherited(arguments);
			}
		}
	});
});
